import { ChangeEvent, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { ACCEPTED_FORMATS } from '@shared/constants';

import {
    InputHolder,
    InputWrapper,
    UploadButton,
    UploadInput,
} from './FileUpload.styled';

interface FileUploadProps {
    acceptedFiles?: string | string[];
    className?: string;
    disabled?: boolean;
    handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
    hideList?: boolean;
    label?: string;
    maxSize?: number;
    multipleFiles?: boolean;
    name: string;
    placeholder?: string;
}

export const FileUpload = ({
    className,
    disabled,
    handleChange,
    multipleFiles = true,
    name,
}: FileUploadProps) => {
    const { t } = useTranslation();
    const hiddenFileInput = useRef<HTMLInputElement>(null);

    const handleClick = () => {
        hiddenFileInput?.current?.click();
    };

    return (
        <InputWrapper className={className}>
            <InputHolder>
                <UploadInput
                    accept={ACCEPTED_FORMATS}
                    disabled={!!disabled}
                    multiple={multipleFiles}
                    name={name}
                    onChange={(e) => handleChange(e)}
                    onClick={(event) => {
                        event.currentTarget.value = '';
                    }}
                    ref={hiddenFileInput}
                    type={'file'}
                />

                <UploadButton
                    disabled={!!disabled}
                    iconProps={{
                        icon: 'SvgUpload24',
                        size: 24,
                        themeColors: {
                            default: {
                                'color-1': 'secondary.default',
                            },
                            disabled: {
                                'color-1': 'secondary.disabled',
                            },
                        },
                    }}
                    onClick={handleClick}
                    testId="button_upload-files"
                    variant={'secondary'}
                >
                    {t('REPORT_UPLOAD_FILES')}
                </UploadButton>
            </InputHolder>
        </InputWrapper>
    );
};
